import { Injectable } from '@angular/core';
import { rethrowAsSapError } from 'src/app/lego-utils';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Partner } from 'src/app/models/domain';
import { PartnerAdapter } from 'src/app/models/domain/adapters';
import { YpmPartnerVService } from 'src/generated-clients/partner';

@Injectable({
  providedIn: 'root',
})
export class PartnerDataService {
  public constructor(
    private readonly partnerVService: YpmPartnerVService,
    private readonly partnerAdapter: PartnerAdapter
  ) {}

  public getPartnersByObjectNumber(objectNumber: string): Observable<Partner[]> {
    return this.partnerVService
      .ypmPartnerVGet(
        undefined,
        undefined,
        `ObjectNumber eq '${objectNumber}' and PartnerFunction eq 'MG'`
      )
      .pipe(
        rethrowAsSapError(),
        map((res) => {
          if (!res.d?.results) {
            throw new Error('SAP Error');
          }

          return res.d.results.map((partner) => this.partnerAdapter.adaptToDomain(partner));
        })
      );
  }
}
